import { render, staticRenderFns } from "./MainGroups.vue?vue&type=template&id=cd6dd770&scoped=true"
import script from "./MainGroups.vue?vue&type=script&lang=ts"
export * from "./MainGroups.vue?vue&type=script&lang=ts"
import style0 from "./MainGroups.vue?vue&type=style&index=0&id=cd6dd770&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6dd770",
  null
  
)

export default component.exports